import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs/internal/observable/of";
import { catchError, map, switchMap } from "rxjs/operators";
import { SoundProfileAction } from "./sound-profile.action";
import { SoundProfileService } from "./sound-profile.service";
import { BsModalAlertComponent, createAlertModalOptions } from '../../core/modal/modal-alert.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Injectable()
export class SoundProfileEffects {
  constructor(
    private actions$: Actions,
    private soundProfileService: SoundProfileService,
    private modalService: BsModalService
  ) {}

  getParentProfiles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoundProfileAction.getParentProfiles),
      switchMap((action: any) =>
        this.soundProfileService.getParentProfiles().pipe(
          map((response: any) =>
            SoundProfileAction.getParentProfilesSuccess({
              parentProfiles: response.parentProfiles,
            })
          )
        )
      )
    )
  );

  getSoundProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoundProfileAction.getSoundProfile),
      switchMap((action: any) =>
        this.soundProfileService
          .getSoundProfile(action.userId, action.parentSoundProfileId)
          .pipe(
            map((response: any) =>
              SoundProfileAction.getSoundProfileSuccess({
                soundProfile: response,
              })
            ),
            catchError((error) =>
              of(SoundProfileAction.getSoundProfileFail({ error }))
            )
          )
      )
    )
  );

    getSoundProfileWithAdaptive$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SoundProfileAction.getSoundProfileWithAdaptive),
            switchMap((action: any) =>
                this.soundProfileService
                    .getSoundProfileWithAdaptive(action.userId, action.parentSoundProfileId)
                    .pipe(
                        map((response: any) =>
                            SoundProfileAction.getSoundProfileSuccess({
                                soundProfile: response,
                            })
                        ),
                        catchError((error) =>
                            of(SoundProfileAction.getSoundProfileFail({ error }))
                        )
                    )
            )
        )
    );

  addUpdateSoundProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoundProfileAction.addUpdateSoundProfile),
      switchMap((action: any) =>
        this.soundProfileService
          .addUpdateSoundProfile(action.userId, action.soundProfiles)
          .pipe(
            map((response: any) =>
              SoundProfileAction.getSoundProfile({
                userId: action.userId,
                parentSoundProfileId: null,
              })
            ),
            catchError((error) =>
              of(SoundProfileAction.addUpdateSoundProfileFail())
            )
          )
      )
    )
  );

  addParentSoundProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoundProfileAction.addParentSoundProfile),
      switchMap((action: any) =>
        this.soundProfileService
          .addParentSoundProfileId(action.userId, action.parentProfileId)
          .pipe(
            map((response: any) =>
              SoundProfileAction.addParentSoundProfileSuccess()
            ),
            catchError((error) =>
              of(SoundProfileAction.addUpdateSoundProfileFail())
            )
          )
      )
    )
  );

  scanAr2Sounds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoundProfileAction.scanAr2VoiceTemplate),
      switchMap(({ userId, userName }) =>
        this.soundProfileService.scanAR2VoiceTemplates(userId, userName).pipe(
          switchMap((response: any) => [
                  SoundProfileAction.scanAr2VoiceTemplateSuccess({
                      scannedSoundProfile: response,
                  }),
                  SoundProfileAction.openAlertOnAr2Scan({
                      templatesWithDifferentContent: response.templatesWithDifferentContent,
                  })
               ]
          ),
          catchError((error) =>
            of(SoundProfileAction.scanAr2VoiceTemplateFail())
          )
        )
      )
    )
  );

  addParentSoundProfileAndSaveSounds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SoundProfileAction.addParentSoundProfileAndSaveSounds),
      switchMap(({ userId, parentProfileId, soundProfiles }) =>
        this.soundProfileService
          .addParentSoundProfileId(userId, parentProfileId)
          .pipe(
            switchMap((response: any) =>
              of(
                SoundProfileAction.addParentSoundProfileSuccess(),
                SoundProfileAction.addUpdateSoundProfile({
                  userId,
                  soundProfiles,
                })
              )
            ),
            catchError((error) =>
              of(SoundProfileAction.addUpdateSoundProfileFail())
            )
          )
      )
    )
  );


    openTemplatesAreDifferentAlert$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SoundProfileAction.openAlertOnAr2Scan),
                map(
                    ( {templatesWithDifferentContent} ) => {
                        if (templatesWithDifferentContent.length > 0) {
                            this.modalService
                                .show(BsModalAlertComponent,
                                    createAlertModalOptions('Alert', 'AR2Template: ' + templatesWithDifferentContent.substr(0, templatesWithDifferentContent.length - 2) + ' contains values different than default!'));
                        }
                    }
                )
            ),
        { dispatch: false }
    );
}
